<template>
  <v-layout>
    <v-switch v-model="value" @change="change"> </v-switch>
  </v-layout>
</template>

<script>
import entities from "../../api/entities";

export default {
  name: "SwitchColumn",
  props: ["entity_type", "entity", "column", "value"],
  methods: {
    async change() {
      const data = {};
      data[this.column.name] = this.value;
      const result = await entities.update(
        this.token,
        this.entity_type,
        this.entity.id,
        data
      );

      const color = result.success ? "green" : "red";
      this.$root.$emit("notify", result.message || "Успешно сохранено", color);
      this.$emit("input", this.value);
    }
  }
};
</script>

<style scoped></style>
